import { render } from "./ProductConfig.vue?vue&type=template&id=358d8bf2&scoped=true"
import script from "./ProductConfig.vue?vue&type=script&lang=js"
export * from "./ProductConfig.vue?vue&type=script&lang=js"

import "./ProductConfig.vue?vue&type=style&index=0&id=358d8bf2&scoped=true&lang=scss"

import exportComponent from "/Users/lucky02/Desktop/project/hw_businessManagement/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-358d8bf2"]])

export default __exports__